var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrendChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1599",
    "data-name": "Group 1599",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70",
    "data-name": "Rectangle 70",
    width: 24,
    height: 24,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M43.5,55.75a.75.75,0,0,1-.75.75h-18a.75.75,0,0,1-.75-.75v-15a.75.75,0,0,1,1.5,0V50.941l4.716-4.725a.759.759,0,0,1,1.069,0l2.466,2.475,4.566-4.566-1.35-1.341a.787.787,0,0,1-.159-.825A.759.759,0,0,1,37.5,41.5h3.75a.75.75,0,0,1,.75.75V46a.75.75,0,0,1-.459.694.8.8,0,0,1-.291.056.778.778,0,0,1-.534-.216l-1.341-1.35-5.091,5.1a.759.759,0,0,1-1.069,0L30.75,47.809l-5.25,5.25V55H42.75A.75.75,0,0,1,43.5,55.75Z",
    transform: "translate(-21.75 -36.25)",
    fill: "#e86262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendChart);
export default __webpack_public_path__ + "static/media/TREND_CHART.6ac3361b094e105fbb76c3305b2cbfc8.svg";
export { ForwardRef as ReactComponent };